import Fetch from "../utils/fetch";

export const fetchMaterialWithProductionActiveByLabeledFamilyCenter = (idLabeledFamilyCenter) => {
  return Fetch.get(`material/obterMateriaisComProducaoAtivoPorFamiliaRotuladaCentro/${idLabeledFamilyCenter}`).then(({ data }) => data)
}

export const fetchMateriaisByUnitAndSupplier = (idBusinessUnit, idSupplier) =>
  Fetch.get(`material/obterMateriaisPorUnidadeNegocioFornecedores/${idBusinessUnit}/${idSupplier}`).then(({ data }) => data)
